import React from 'react';

import { TSvgIcon } from '../types';

export const ArrowRightIcon: TSvgIcon = ({ width = 25, height = 24 }): JSX.Element => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.79006 6.71002C9.40006 7.10002 9.40006 7.73002 9.79006 8.12002L13.6701 12L9.79006 15.88C9.40006 16.27 9.40006 16.9 9.79006 17.29C10.1801 17.68 10.8101 17.68 11.2001 17.29L15.7901 12.7C16.1801 12.31 16.1801 11.68 15.7901 11.29L11.2001 6.70002C10.8201 6.32002 10.1801 6.32002 9.79006 6.71002Z"
                fill="white"
            />
        </svg>
    );
};
